/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Minimal back-reference to the parent entry embedded inside child objects
 * @export
 * @interface EntrySummary
 */
export interface EntrySummary {
    /**
     * 
     * @type {string}
     * @memberof EntrySummary
     */
    relationshipId: string;
    /**
     * 
     * @type {string}
     * @memberof EntrySummary
     */
    entryStart: string;
    /**
     * 
     * @type {string}
     * @memberof EntrySummary
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof EntrySummary
     */
    updated?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntrySummary
     */
    isCreatedByService: boolean;
}

/**
 * Check if a given object implements the EntrySummary interface.
 */
export function instanceOfEntrySummary(value: object): value is EntrySummary {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('entryStart' in value) || value['entryStart'] === undefined) return false;
    if (!('isCreatedByService' in value) || value['isCreatedByService'] === undefined) return false;
    return true;
}

export function EntrySummaryFromJSON(json: any): EntrySummary {
    return EntrySummaryFromJSONTyped(json, false);
}

export function EntrySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntrySummary {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'entryStart': json['entryStart'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'isCreatedByService': json['isCreatedByService'],
    };
}

export function EntrySummaryToJSON(json: any): EntrySummary {
    return EntrySummaryToJSONTyped(json, false);
}

export function EntrySummaryToJSONTyped(value?: EntrySummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'entryStart': value['entryStart'],
        'created': value['created'],
        'updated': value['updated'],
        'isCreatedByService': value['isCreatedByService'],
    };
}

